export const isTrackingDataMatch = ({ trackData, trackCompletedData }) => {
    const trackEventName = trackData.event;
    const tealiumEventName = trackCompletedData.event.tealium_event;
    return !!trackEventName && !!tealiumEventName && trackEventName === tealiumEventName;
};
